import { startCase } from 'lodash/fp';
import PropTypes from 'prop-types';
import { BASE, DASHBOARD } from '../../../../../../routes';
import AdminHelpList from '../../../../../components/AdminHelpList';
import ApiWarning from '../../../../../components/ApiWarning';
import Button from '../../../../../components/Button';
import { DeprecatedButtonContainer } from '../../../../../components/ButtonContainer';
import { WithModal } from '../../../../../hoc/withModal';
import { getDefaultNoReviewerErrorWording } from '../../../services/wording';
import styles from './style.m.less';

NoAssessment.propTypes = {
    message: PropTypes.node,
    adminsToContact: PropTypes.array,
    showHomeButton: PropTypes.bool,
};

export default function NoAssessment({ message = '', adminsToContact = [], showHomeButton = true }) {
    const errorMessage = message ? message : getDefaultNoReviewerErrorWording();
    const AdminsModal = () => (
        <WithModal
            size="LG_WIDTH"
            renderModalContent={() => (
                <AdminHelpList adminIds={adminsToContact}>
                    {adminWording => <h1>{startCase(adminWording)}</h1>}
                </AdminHelpList>
            )}
        >
            {({ openModal }) => <Button onClick={openModal}>View Admins</Button>}
        </WithModal>
    );

    return (
        <ApiWarning>
            <div className={styles.noAssessment}>
                <p>{errorMessage}</p>
                {showHomeButton && (
                    <DeprecatedButtonContainer>
                        {/* FIXME */}
                        {/* eslint-disable-next-line react-hooks/static-components */}
                        {adminsToContact.length !== 0 && <AdminsModal />}
                        <a href={BASE + DASHBOARD} className="button save">
                            Home
                        </a>
                    </DeprecatedButtonContainer>
                )}
            </div>
        </ApiWarning>
    );
}
